import React, { useEffect, useState } from 'react';
import SearchSection from '../Components/SearchSection';
import MenuSection from '../Components/MenuSection';
import { useParams } from 'react-router-dom';
import { _get } from '../services/apiClient';
import { useSearch } from '../SearchContext';

function Product({ handleClick, cart, setCart, handleCartClick }) {
    const [products, setProducts] = useState([]);
    const [offset, setOffset] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [subCategories, setSubCategories] = useState([]);
    const [isFetching, setIsFetching] = useState(false); 
    const { id } = useParams();
    const { filtersubCategory } = useSearch();
    const { searchAllCategories, searchData } = useSearch();
    useEffect(() => {
        fetchSubCategoryData();
    }, []);

    useEffect(() => {
        goToTop();
        setOffset(1);
        setProducts([]);  
        fetchData(1, true);
    }, [id, filtersubCategory]);

    useEffect(() => {
        setOffset(1);
        setProducts([]);
        fetchData(1, true);
      }, [id, filtersubCategory, searchData, searchAllCategories]);
    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop >=
                document.documentElement.offsetHeight - 10
            ) {
                if (offset < totalPages && !isFetching) {
                    setOffset(prevOffset => prevOffset + 1);
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll); 
    }, [offset, totalPages, isFetching]);

    useEffect(() => {
        if (offset > 1) fetchData(offset, false);
    }, [offset]);

    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const fetchData = async (page, isReset) => {
        try {
          setIsFetching(true);
      
          let url = '';
          if (searchAllCategories && searchData) {
            url = `/products?search=${searchData}&page=${page}&limit=20`;
          } else {
            url = `/products?category=${id}&page=${page}&limit=20`;
          }
      
          const response = await _get(url);
          if (isReset) {
            setProducts(response.data.products);
          } else {
            setProducts(prev => [...prev, ...response.data.products]);
          }
      
          setTotalPages(response.data.totalPages);
          setIsFetching(false);
        } catch (error) {
          console.error('Error fetching data:', error);
          setIsFetching(false);
        }
      };
      

    const fetchSubCategoryData = async () => {
        try {
            const response = await _get(`/subcategory`);
            setSubCategories(response.data);
        } catch (error) {
            console.error('Error fetching subcategories:', error);
        }
    };

    return (
        <>
            <SearchSection handleClick={handleClick} catId={id} subCategories={subCategories} cart={cart} />
            <MenuSection
                products={products}
                subCategories={subCategories}
                handleClick={handleClick}
                handleCartClick={handleCartClick}
                cart={cart}
                setCart={setCart}
            />
        </>
    );
}

export default Product;
